import {split} from "lodash";

function printTemplateA5(title, list, LODOP) {
    // console.log(title, list)
    // 表格绘制
    let lineWidth = 1;
    let tableWidth = 500 // 表格宽度
    let tableLeft = 15; // 表格左外边距
    let fontSize = 10
    let contentFontSize = 9
    let marginTop = 35;

    LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A5')
    // LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1) // 打印旋转

    // LODOP.SET_PRINT_PAGESIZE(1, '148mm', '210mm', '处方');

    LODOP.ADD_PRINT_TEXT(marginTop - 15, tableLeft, 540, 30, isEmptyStr(title.recordId) ? `NO.${title.recordId}` : '');
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 1);
    setFontSizeAndColor(7, "#000000", LODOP)

    LODOP.ADD_PRINT_HTM(marginTop - 20, tableLeft + 435, 540, 30, `<div style="border: 1px solid #000; width: 40px; height: 20px; text-align: center; line-height: 18px; font-size: 10px;">普通</div>`);

    LODOP.ADD_PRINT_TEXT(marginTop - 15, tableLeft + 400, 100, 30, "#/&");
    LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
    setFontSizeAndColor(7, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 15, 0, 540, 30, isEmptyStr(title.company));
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    setFontSizeAndColor(18, "#000000", LODOP)
    // LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 15);//字间距

    LODOP.ADD_PRINT_TEXT(marginTop + 45, 0, 540, 30, isEmptyStr(list[0].printTypeTitle));
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    setFontSizeAndColor(13, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 80, tableLeft, 540, 30, `姓名：${isEmptyStr(title.patientName)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 80, tableLeft + 160, 540, 30, `性别：${isEmptyStr(title.sex)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 80, tableLeft + 230, 540, 30, `年龄：${isEmptyStr(getAge(title.clinicalAge, title.year, title.month, title.day))}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 80, tableLeft + 340, 540, 30, `医生: ${title.printDoctorName == 1 ? isEmptyStr(title.realName) : ''}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    // LODOP.ADD_PRINT_LINE(marginTop + 108, tableLeft, marginTop + 108, tableLeft + tableWidth + 1, 0, lineWidth);// 第一条横线
    // LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 100, tableLeft, 700, 30, `手机号：${isEmptyStr(title.phoneNo)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 100, tableLeft + 160, 540, 30, `科室：${isEmptyStr(title.laboratoryName)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 100, tableLeft + 340, 540, 30, `就诊日期：${isEmptyStr(title.clinicalTime)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    // LODOP.ADD_PRINT_LINE(marginTop + 138, tableLeft, marginTop + 138, tableLeft + tableWidth + 1, 0, lineWidth);// 第二条横线
    // LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 120, tableLeft, 700, 30, `临床诊断：${isEmptyStr(title.diagnosisResultString)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    // LODOP.ADD_PRINT_LINE(marginTop + 168, tableLeft, marginTop + 168, tableLeft + tableWidth + 1, 0, lineWidth);// 第三条横线
    // LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    // content
    let tableHtml = '<table border="1" style="border-collapse:collapse; font-size: 12px;">'

    tableHtml += `
            <tr style="text-align: left;" height="30px">
                <td colspan="10">过敏史: ${isEmptyStr(title.allergyHistory)}</td>
            </tr>
        `

    for (let i = 0; i < list.length; i++) {
        let ele = list[i]

        if (ele.printType == 'time') {
            tableHtml += `
             <tr style="text-align: left;" height="30px">
                <td colspan="10">
                    <div style="float: left">${isEmptyStr(ele.printIndex)}</div>
                    <div style="width: 150px; float: right">签名:</div>
                </td>
             </tr>
        `
        } else if (ele.printType == 'title') {
            tableHtml += `
            <tr style="text-align: center;" height="30px">
                <td width="30px">${isEmptyStr(ele.printIndex)}</td>
                <td width="180px">项目</td>
                <td width="40px">单量</td>
                <td width="40px">用法</td>
                <td width="40px">频次</td>
                <td width="40px">天数</td>
                <td width="40px">总量</td>
                <td width="40px">执行时间</td>
                <td width="40px">备注</td>
                <td width="60px">签名</td>
            </tr>
        `
        } else  {
            tableHtml += `
             <tr style="text-align: center;" height="30px">
                <td width="30px">${isEmptyStr(ele.printIndex)}</td>
                <td width="180px">${isEmptyStr(ele.drugName)} ${isEmptyStr(ele.specification)}</td>
                <td width="40px">${isEmptyStr(ele.dosage)}${isEmptyStr(ele.dosageUnit)}</td>
                <td width="40px">${isEmptyStr(ele.usage)}</td>
                <td width="40px">${isEmptyStr(ele.useRate)}</td>
                <td width="40px">${isEmptyStr(ele.dayCount)}</td>
                <td width="40px">${isEmptyStr(ele.totalDosage)}${isEmptyStr(ele.totalDosageUnit)}</td>
                <td width="40px"></td>
                <td width="40px">${isEmptyStr(ele.skinTest)}</td>
                <td width="60px"></td>
             </tr>
        `
        }
    }

    tableHtml += `</table>`

    LODOP.ADD_PRINT_TABLE(marginTop + 140, tableLeft, tableWidth, 900, tableHtml)
}

function printTemplateSmallA5(title, list, LODOP) {
    // console.log(title, list)
    // 表格绘制
    let lineWidth = 1;
    let tableWidth = 450 // 表格宽度
    let tableLeft = 15; // 表格左外边距
    let fontSize = 9
    let contentFontSize = 9
    let marginTop = 35;

    // LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A5')
    // LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1) // 打印旋转

    LODOP.SET_PRINT_PAGESIZE(1, '130mm', '190mm', '处方');

    LODOP.ADD_PRINT_TEXT(marginTop - 15, tableLeft, tableWidth, 30, isEmptyStr(title.recordId) ? `NO.${title.recordId}` : '');
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 1);
    setFontSizeAndColor(7, "#000000", LODOP)

    LODOP.ADD_PRINT_HTM(marginTop - 20, tableLeft + 380, 540, 30, `<div style="border: 1px solid #000; width: 40px; height: 20px; text-align: center; line-height: 18px; font-size: 10px;">普通</div>`);

    LODOP.ADD_PRINT_TEXT(marginTop - 15, tableLeft + 350, 100, 30, "#/&");
    LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
    setFontSizeAndColor(7, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 15, 0, tableWidth, 30, isEmptyStr(title.company));
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    setFontSizeAndColor(18, "#000000", LODOP)
    // LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 15);//字间距

    LODOP.ADD_PRINT_TEXT(marginTop + 45, 0, tableWidth, 30, isEmptyStr(list[0].printTypeTitle));
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    setFontSizeAndColor(13, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 80, tableLeft, 540, 30, `姓名：${isEmptyStr(title.patientName)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 80, tableLeft + 150, 540, 30, `性别：${isEmptyStr(title.sex)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 80, tableLeft + 210, 540, 30, `年龄：${isEmptyStr(getAge(title.clinicalAge, title.year, title.month, title.day))}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 80, tableLeft + 310, 540, 30, `医生: ${title.printDoctorName == 1 ? isEmptyStr(title.realName) : ''}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    // LODOP.ADD_PRINT_LINE(marginTop + 108, tableLeft, marginTop + 108, tableLeft + tableWidth + 1, 0, lineWidth);// 第一条横线
    // LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 100, tableLeft, 700, 30, `手机号：${isEmptyStr(title.phoneNo)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 100, tableLeft + 150, 540, 30, `科室：${isEmptyStr(title.laboratoryName)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 100, tableLeft + 310, 540, 30, `就诊日期：${isEmptyStr(title.clinicalTime)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    // LODOP.ADD_PRINT_LINE(marginTop + 138, tableLeft, marginTop + 138, tableLeft + tableWidth + 1, 0, lineWidth);// 第二条横线
    // LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 120, tableLeft, 700, 30, `临床诊断：${isEmptyStr(title.diagnosisResultString)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    // LODOP.ADD_PRINT_LINE(marginTop + 168, tableLeft, marginTop + 168, tableLeft + tableWidth + 1, 0, lineWidth);// 第三条横线
    // LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    // content
    let tableHtml = '<table border="1" style="border-collapse:collapse; font-size: 10px;">'

    tableHtml += `
            <tr style="text-align: left;" height="30px">
                <td colspan="10">过敏史: ${isEmptyStr(title.allergyHistory)}</td>
            </tr>
        `

    for (let i = 0; i < list.length; i++) {
        let ele = list[i]

        if (ele.printType == 'time') {
            tableHtml += `
             <tr style="text-align: left;" height="30px">
                <td colspan="10">
                    <div style="float: left">${isEmptyStr(ele.printIndex)}</div>
                    <div style="width: 150px; float: right">签名:</div>
                </td>
             </tr>
        `
        } else if (ele.printType == 'title') {
            tableHtml += `
            <tr style="text-align: center;" height="30px">
                <td width="30px">${isEmptyStr(ele.printIndex)}</td>
                <td width="180px">项目</td>
                <td width="40px">单量</td>
                <td width="40px">用法</td>
                <td width="40px">频次</td>
                <td width="40px">天数</td>
                <td width="40px">总量</td>
                <td width="40px">执行时间</td>
                <td width="40px">备注</td>
                <td width="60px">签名</td>
            </tr>
        `
        } else  {
            tableHtml += `
             <tr style="text-align: center;" height="30px">
                <td width="30px">${isEmptyStr(ele.printIndex)}</td>
                <td width="180px">${isEmptyStr(ele.drugName)} ${isEmptyStr(ele.specification)}</td>
                <td width="40px">${isEmptyStr(ele.dosage)}${isEmptyStr(ele.dosageUnit)}</td>
                <td width="40px">${isEmptyStr(ele.usage)}</td>
                <td width="40px">${isEmptyStr(ele.useRate)}</td>
                <td width="40px">${isEmptyStr(ele.dayCount)}</td>
                <td width="40px">${isEmptyStr(ele.totalDosage)}${isEmptyStr(ele.totalDosageUnit)}</td>
                <td width="40px"></td>
                <td width="40px">${isEmptyStr(ele.skinTest)}</td>
                <td width="60px"></td>
             </tr>
        `
        }
    }

    tableHtml += `</table>`

    LODOP.ADD_PRINT_TABLE(marginTop + 140, tableLeft, tableWidth, 900, tableHtml)
}

const isEmptyStr = (value) => {
    if (value == null || value == undefined || value == '') {
        return ''
    }
    return value
}

const setFontSizeAndColor = (fontSize, color, LODOP) => {
    LODOP.SET_PRINT_STYLEA(0, "FontSize", fontSize);
    LODOP.SET_PRINT_STYLEA(0, "FontColor", color);
}

const getAge = (clinicalAge, year, month, day) => {
    if (clinicalAge) {
        return clinicalAge
    } else {
        let str = ''
        if (year > 0) {
            str += `${year}岁`
        }
        if (month > 0 && year >= 0 && year < 5) {
            str += `${month}月`
        }
        if (year === 0 && day > 0) {
            str += `${day}天`
        }
        return str
    }
}

export { printTemplateA5, printTemplateSmallA5 }